import moment from 'moment-timezone';

import { Exception, ScheduleHours } from '../models';
import { generateIntervals } from './generate-intervals';
import { getExceptions } from './get-exceptions';
import { mergeIntervals } from './merge-intervals';
import { Intervals } from '../types';

export function getIntervals(
  hours: ScheduleHours,
  exceptions: Exception[],
  timestamp: number,
  timezone: string,
  includeNextDay = true,
  isPublic = false,
): Intervals {
  const today = moment.tz(timestamp, timezone);
  const previousDay = moment.tz(timestamp, timezone).subtract(1, 'day');

  const intervals = [
    ...generateIntervals(
      hours[previousDay.format('ddd')],
      getExceptions(exceptions, previousDay.format('D-M-YYYY'), timezone),
      previousDay,
      timezone,
      isPublic,
    ),
    ...generateIntervals(
      hours[today.format('ddd')],
      getExceptions(exceptions, today.format('D-M-YYYY'), timezone),
      today,
      timezone,
      isPublic,
    ),
  ];
  if (includeNextDay) {
    const nextDay = moment.tz(timestamp, timezone).add(1, 'day');
    intervals.push(...generateIntervals(
      hours[nextDay.format('ddd')],
      getExceptions(exceptions, nextDay.format('D-M-YYYY'), timezone),
      nextDay,
      timezone,
      isPublic,
    ));
  }

  return mergeIntervals(intervals);
}